import React, { useState } from 'react';
import { CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton, CFormSelect, CFormInput } from '@coreui/react';
import config from '../../../utils/EnvironmentSwitcher'; // Import config utility

const LinkRobotModal = ({ isVisible, onClose, handleLinkRobotSerial, authUser }) => {
      const [selectedLoinc, setSelectedLoinc] = useState('');
      const [ssid, setSsid] = useState('');
      const [password, setPassword] = useState('');

      const loincOptions = [
            { code: '1234-5', text: 'Example LOINC 1', description: 'Description 1' },
            { code: '6789-0', text: 'Example LOINC 2', description: 'Description 2' },
            // Add more LOINC options as needed
      ];

      const handleLink = () => {
            if (!selectedLoinc || !ssid || !password) {
                  alert('Please fill in all fields.');
                  return;
            }

            const loinc = loincOptions.find(option => option.code === selectedLoinc);
            const robotData = {
                  loincCode: loinc.code,
                  loincText: loinc.text,
                  loincDescription: loinc.description,
                  value: 1,
                  uid: authUser.uid,
                  ssid,
                  password,
                  fhirEndpoint: config.fhirUrl, // Add FHIR endpoint from config
            };

            handleLinkRobotSerial(robotData);
            onClose();
      };

      return (
            <CModal visible={isVisible} onClose={onClose}>
                  <CModalHeader>
                        <CModalTitle>
                              Link Robot
                              {config.environment === 'development' && (
                                    <span className="badge bg-warning ms-2">Dev</span>
                              )}
                        </CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                        <CFormSelect
                              value={selectedLoinc}
                              onChange={(e) => setSelectedLoinc(e.target.value)}
                              aria-label="Select LOINC Code"
                        >
                              <option value="">Select LOINC Code</option>
                              {loincOptions.map((option) => (
                                    <option key={option.code} value={option.code}>
                                          {option.text} - {option.description}
                                    </option>
                              ))}
                        </CFormSelect>
                        <CFormInput
                              type="text"
                              placeholder="WiFi SSID"
                              value={ssid}
                              onChange={(e) => setSsid(e.target.value)}
                              className="mt-3"
                        />
                        <CFormInput
                              type="password"
                              placeholder="WiFi Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className="mt-3"
                        />
                        <div className="mt-3 mb-2 small">
                              Using FHIR endpoint: {config.fhirUrl}
                        </div>
                  </CModalBody>
                  <CModalFooter>
                        <CButton color="secondary" onClick={onClose}>
                              Close
                        </CButton>
                        <CButton color="primary" onClick={handleLink}>
                              Link Robot
                        </CButton>
                  </CModalFooter>
            </CModal>
      );
};

export default LinkRobotModal;

